import React from 'react';
import { HeroImage, useOidcAuthentication } from '@cp-shared-19/frontend-ui';
import { useTranslation } from 'react-i18next';
import { IdentityBrokerErrorType } from './types';
import { useHistory } from 'react-router-dom';
import { dashboardPagePath, loginRedirectPagePath } from '../../navigation/paths';
import { getGenericErrorTranslationPrefix } from './utils';

export const IdentityBrokerError: React.FC<{ type: IdentityBrokerErrorType }> = ({ type }) => {
    const { t } = useTranslation('identity-broker-error-pages');
    const history = useHistory();
    const { logout } = useOidcAuthentication();

    const handleLogoutAndReLogin = async () => {
        const reLoginPagePath = window.location.origin + loginRedirectPagePath();
        await logout({ post_logout_redirect_uri: reLoginPagePath });
    };

    const onButtonClick = () => {
        if (type === IdentityBrokerErrorType.ALREADY_LOGIN_ERR) {
            history.push(dashboardPagePath());
        } else {
            handleLogoutAndReLogin();
        }
    };

    const translationPrefix = getGenericErrorTranslationPrefix(type);

    const errorPageProps = {
        title: t(`${translationPrefix}.headline`),
        buttonText: t(`${translationPrefix}.button`),
        clickHandler: onButtonClick,
    };

    return (
        <HeroImage
            title={<span id="maincontent">{errorPageProps?.title}</span>}
            buttonText={errorPageProps?.buttonText}
            clickHandler={errorPageProps.clickHandler}
        />
    );
};
